import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StateNamesEnum } from '@app/shared/utils/enums/state-names.enum';
import { PatientProfileState } from './patient-profile.state';
import { SystemPreferenceCode } from '@app/shared/utils/enums/system-preference-code';
import { petHasGrowthChart } from '@app/shared/utils/static-helpers/growth-chart-helper';

/**
 * Patient Profile selectors
 */

const selectPatientProfileState = createFeatureSelector<PatientProfileState>(StateNamesEnum.PATIENT_PROFILE_STATE_NAME);

export const selectProfile = createSelector(selectPatientProfileState, (state) => state?.profile);
export const selectWeight = createSelector(selectPatientProfileState, (state) => state?.weight);
export const selectIsNewPet = createSelector(selectPatientProfileState, (state) => state?.isNewPet);
export const selectOngoingPet = createSelector(selectPatientProfileState, (state) => state?.ongoingPet);

export const selectPetHasGrowthChart = (currentSystemPreferenceCode: SystemPreferenceCode) =>
  createSelector(selectProfile, selectWeight, (patientProfile, patientWeight) => {
    return petHasGrowthChart(
      patientProfile?.lifestage,
      patientProfile?.speciesCode,
      patientWeight?.targetWeight,
      currentSystemPreferenceCode,
    );
  });
